import {
  BasePriceForm,
  BasePriceInputForm,
} from '@/features/dashboard/tourConfig/schemas/tourPricesSchema.ts';
import {
  TourPriceDto,
  TourPriceWriteDto,
} from '@/features/dashboard/tourConfig/types/TourPriceDto.ts';

export const tourPriceDtoMapper = {
  fromFormToDto: (
    tourId: string,
    tourPricesForm: BasePriceForm,
  ): TourPriceWriteDto => {
    const prices: TourPriceDto[] = [];
    if (tourPricesForm.isPriceByAge) {
      tourPricesForm.ageRestrictionPrices.forEach((ageRestrictionPrice) => {
        prices.push({
          name: ageRestrictionPrice.name || undefined,
          price: {
            amount: ageRestrictionPrice.price,
            currency: tourPricesForm.currency,
          },
          ageRestriction: {
            minAge: ageRestrictionPrice.minAge,
            maxAge: ageRestrictionPrice.maxAge,
          },
        });
      });

      if (!tourPricesForm.isVariantOnlyForDefinedAgeRanges) {
        prices.push({
          name: tourPricesForm.priceName || undefined,
          price: {
            amount: tourPricesForm.price,
            currency: tourPricesForm.currency,
          },
        });
      }
    } else {
      prices.push({
        name: tourPricesForm.priceName || undefined,
        price: {
          amount: tourPricesForm.price,
          currency: tourPricesForm.currency,
        },
      });
    }

    return {
      tourId: tourId,
      tourPrices: prices,
    };
  },
  fromDtoToForm: (
    tourPricesDto: TourPriceDto[],
  ): BasePriceInputForm | undefined => {
    if (tourPricesDto.length === 0) {
      return;
    }

    const priceWithoutAgeRestriction = tourPricesDto.find(
      (price) => !price.ageRestriction,
    );

    const ageRestrictionPrices = tourPricesDto
      .filter((p) => p.ageRestriction)
      .map((p) => ({
        name: p.name ?? undefined,
        minAge: p.ageRestriction!.minAge,
        maxAge: p.ageRestriction!.maxAge,
        price: p.price.amount,
      }));

    let isPriceByAge = tourPricesDto.length > 1;
    if (
      tourPricesDto.length === 1 &&
      tourPricesDto[0].ageRestriction !== null
    ) {
      isPriceByAge = true;
    }

    return {
      currency: tourPricesDto[0].price.currency,
      price: priceWithoutAgeRestriction?.price.amount ?? undefined,
      priceName: priceWithoutAgeRestriction?.name ?? undefined,
      isPriceByAge: isPriceByAge,
      isVariantOnlyForDefinedAgeRanges:
        priceWithoutAgeRestriction === undefined,
      ageRestrictionPrices: ageRestrictionPrices,
    };
  },
};
